import { createFileRoute, redirect } from '@tanstack/react-router';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { getAuthStore } from '../main';
import { ContestEdit } from '../components/ContestEdit';

export const Route = createFileRoute('/prize-settings_/$contestId')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { contestId } = Route.useParams();
  const adminRole = getAuthStore().getUser()?.role;

  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Edit Prize</h1>
        <ContestEdit contestId={contestId} adminRole={adminRole} />
      </Pane>
    </>
  );
}
